import { translate } from "app/filters/i18nFilter";
import type { IRadioSelectItem } from "app/pages/sales-intelligence/common-components/form-fields";
import { binaryInclusionOptions, type InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";
import { commonKeys } from "app/pages/sales-intelligence/utils/i18n/common";

import type { GroupType } from "./types";

export const createRadioOptions = (groupType: GroupType): readonly IRadioSelectItem[] =>
    groupType === "binary"
        ? binaryInclusionOptions.map(
              (inclusionOption: InclusionOption): IRadioSelectItem => ({
                  id: inclusionOption,
                  text: translate(commonKeys.inclusion(inclusionOption)),
              }),
          )
        : [];
